import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Heading,
} from '@chakra-ui/react';

const faqs = [
  {
    question: 'What does Ajanta Cloth House sell?',
    answer: "We offer suiting, shirting, fabrics, men's and women's clothing, and ethnic wear.",
  },
  {
    question: 'Where is Ajanta Cloth House located?',
    answer: 'Our store is in Sirsa, Haryana, India. Use the Locate Us link below for directions.',
  },
  {
    question: 'How can I contact the store?',
    answer: 'Call 9254322231 or email Ajantasirsa@gmail.com for product and store enquiries.',
  },
];

export default function FAQ() {
  return (
    <Box
      as="section"
      aria-labelledby="faq-heading"
      maxW="900px"
      mx="auto"
      px={{ base: 4, md: 8 }}
      py={{ base: 8, md: 12 }}
    >
      <Heading id="faq-heading" as="h2" size="lg" mb={6} color="#2c7a7b">
        Frequently Asked Questions
      </Heading>
      <Accordion allowMultiple reduceMotion>
        {faqs.map(({ question, answer }) => (
          <AccordionItem key={question}>
            <h3>
              <AccordionButton py={5} _expanded={{ color: '#184a49' }}>
                <Box as="span" flex="1" textAlign="left" fontWeight="semibold">
                  {question}
                </Box>
                <AccordionIcon />
              </AccordionButton>
            </h3>
            <AccordionPanel pb={5} lineHeight="tall">
              {answer}
            </AccordionPanel>
          </AccordionItem>
        ))}
      </Accordion>
    </Box>
  );
}
